// Centralized Payment Providers registry for maintainability
// Add or update providers here; UI and other features should consume this list.

export type PaymentProviderId = 'epag' | 'stripe' | 'ibanfirst';

export type ProviderStatus = 'implemented' | 'planned' | 'deprecated';

export interface PaymentProvider {
  id: PaymentProviderId;
  name: string;
  description: string;
  category: string; // e.g., 'Boleto', 'Card Processor', 'Bank Transfer'
  status: ProviderStatus;
  tags?: string[];
  hasFrontend: boolean;
  hasBackend: boolean;
  docsUrl?: string;
  links?: { label: string; href: string }[];
}

export const PAYMENT_PROVIDERS: PaymentProvider[] = [
  {
    id: 'epag',
    name: 'ePag',
    description:
      'Brazilian Boleto payments via ePag. Supports boleto generation, status checks and downloads.',
    category: 'Boleto',
    status: 'implemented',
    tags: ['boleto', 'br'],
    hasFrontend: true,
    hasBackend: true,
    docsUrl: '/EPAG_INTEGRATION_README.md',
    links: [
      { label: 'EPAG_README', href: '/EPAG_INTEGRATION_README.md' },
    ],
  },
  {
    id: 'stripe',
    name: 'Stripe',
    description:
      'Automatic invoice charging for cards and SEPA direct debit with asynchronous reconciliation.',
    category: 'Card Processor',
    status: 'implemented',
    tags: ['cards', 'sepa', 'off-session'],
    hasFrontend: true,
    hasBackend: true,
  },
  {
    id: 'ibanfirst',
    name: 'iBanFirst',
    description:
      'Bank transfer reconciliation against iBanFirst wallet movements to match and align invoice payments.',
    category: 'Bank Transfer',
    status: 'implemented',
    tags: ['bank-transfer', 'reconciliation'],
    hasFrontend: true,
    hasBackend: true,
  },
];

export const getProviderById = (id: PaymentProviderId): PaymentProvider | undefined =>
  PAYMENT_PROVIDERS.find((p) => p.id === id);
